var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-progress-circular',{staticClass:"mb-3",attrs:{"indeterminate":"","color":"primary","size":50}}),_c('p',{staticClass:"overline text--disabled"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.textLoader))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }